import { render } from "./CreateItemModal.vue?vue&type=template&id=33e0786f&scoped=true"
import script from "./CreateItemModal.vue?vue&type=script&lang=js"
export * from "./CreateItemModal.vue?vue&type=script&lang=js"

import "./CreateItemModal.vue?vue&type=style&index=0&id=33e0786f&scoped=true&lang=css"
import "./CreateItemModal.vue?vue&type=style&index=1&id=33e0786f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e0786f"]])

export default __exports__